const privacy = {
  'privacy.page.backToTop': 'Back to top',
  'privacy.page.lastUpdated': 'Last updated: 13 June 2026',
  'privacy.page.homeLink': 'Home',
  'privacy.page.currentPage': 'Privacy Policy',

  'privacy.hero.homeLink': 'Home',
  'privacy.hero.currentPage': 'Privacy Policy',
  'privacy.hero.title': 'Privacy Policy',
  'privacy.hero.titleEn': 'PRIVACY POLICY',
  'privacy.hero.lead': 'The All Japan Butler Association (the "Association") sets out below its policy for handling personal information collected in connection with the operation of The Japan Butler Academy.',
  'privacy.hero.imgAlt': 'Privacy Policy',

  'privacy.jsonld.breadcrumb1': 'Home',
  'privacy.jsonld.breadcrumb2': 'Privacy Policy',
  'privacy.jsonld.orgName': 'The Japan Butler Academy',
  'privacy.jsonld.parentOrg': 'The All Japan Butler Association',

  'privacy.toc.title': 'Contents',
  'privacy.toc.subtitleEn': 'CONTENTS',
  'privacy.article.prefix': 'Article ',
  'privacy.article.suffix': '',

  'privacy.related.title': 'Related Pages',
  'privacy.related.0.title': 'Terms of Service',
  'privacy.related.0.desc': 'Conditions of use for this website',
  'privacy.related.1.title': 'Commercial Transactions Act Disclosure',
  'privacy.related.1.desc': 'Statutory disclosure information',
  'privacy.related.2.title': 'Contact',
  'privacy.related.2.desc': 'Questions and enquiries',
  'privacy.related.viewMore': 'View',

  // PrivacyContent UI chrome
  'privacy.toc.heading': 'Contents',
  'privacy.content.preamble': 'The All Japan Butler Association (the "Association") complies with the Act on the Protection of Personal Information and other applicable laws, and handles personal information collected in connection with the operation of The Japan Butler Academy in accordance with the policy set out below. This Policy applies to all personal information collected by the Association.',
  'privacy.content.enactDate': 'Effective Date',
  'privacy.content.enactDateValue': 'To be announced',
  'privacy.content.lastRevised': 'Last Revised',
  'privacy.content.lastRevisedValue': '13 June 2026',
  'privacy.content.amendNotice': 'This Privacy Policy may be revised without prior notice.',

  // Article titles
  'privacy.a.01.title': 'Operator Information',
  'privacy.a.02.title': 'Personal Information Collected',
  'privacy.a.03.title': 'Purpose of Use',
  'privacy.a.04.title': 'Provision to Third Parties',
  'privacy.a.05.title': 'Outsourcing',
  'privacy.a.06.title': 'Security Management',
  'privacy.a.07.title': 'Requests for Disclosure, Correction, and Deletion',
  'privacy.a.08.title': 'Cookies and Access Analytics',
  'privacy.a.09.title': 'Contact',
  'privacy.a.10.title': 'Amendments',

  // Article 1 content
  'privacy.a.01.p.0': 'The Association is a general incorporated association that operates The Japan Butler Academy. The Association bears responsibility for the handling of personal information relating to this website and the Academy.',
  'privacy.a.01.p.1': 'Name: The All Japan Butler Association (Zennihon Shitsuji Kyokai)',
  'privacy.a.01.p.2': 'Address: 2-7-4 Aomi, Koto-ku, Tokyo',
  'privacy.a.01.p.3': 'Telephone: 03-6824-4086 (Weekdays 10:00–17:00)',
  'privacy.a.01.p.4': 'Email: info@butler-academy.jp',

  // Article 2 content
  'privacy.a.02.p.0': 'The Association collects personal information from users in the following circumstances.',
  'privacy.a.02.p.1': 'Brochure requests: full name, furigana, email address, telephone number (optional), course of interest (optional)',
  'privacy.a.02.p.2': 'Individual consultation enquiries: full name, furigana, email address, telephone number, nature of enquiry, preferred date and time',
  'privacy.a.02.p.3': 'General enquiries and applications: full name, furigana, email address, telephone number, and any other information provided by the user',
  'privacy.a.02.p.4': 'Corporate training enquiries: company name, contact name, department, email address, telephone number, nature of enquiry',

  // Article 3 content
  'privacy.a.03.p.0': 'Personal information collected will be used solely for the following purposes.',
  'privacy.a.03.p.1': '(1) Responding to applications and enquiries',
  'privacy.a.03.p.2': '(2) Sending brochures (PDF)',
  'privacy.a.03.p.3': '(3) Providing information and updates regarding courses and services',
  'privacy.a.03.p.4': '(4) Analysis for service quality improvement',
  'privacy.a.03.p.5': '(5) Compliance with legal obligations',
  'privacy.a.03.p.6': 'Where personal information is to be used beyond the above purposes, the Association will obtain the prior consent of the individual concerned.',

  // Article 4 content
  'privacy.a.04.p.0': 'The Association will not provide personal information to third parties without the consent of the individual, except in the following circumstances.',
  'privacy.a.04.p.1': '(1) Where required by law',
  'privacy.a.04.p.2': '(2) Where necessary to protect the life, body, or property of a person and it is difficult to obtain consent',
  'privacy.a.04.p.3': '(3) Where particularly necessary for improving public health or promoting the sound development of children and it is difficult to obtain consent',
  'privacy.a.04.p.4': '(4) Where it is necessary to cooperate with a national or local government authority or a person entrusted by such authority in carrying out duties prescribed by law, and obtaining consent would be likely to impede the performance of those duties',

  // Article 5 content
  'privacy.a.05.p.0': 'The Association may outsource all or part of the handling of personal information to external parties to the extent necessary for achieving the purposes of use.',
  'privacy.a.05.p.1': 'When outsourcing, the Association will exercise necessary and appropriate supervision over the outsourced party to ensure the safe management of personal information.',
  'privacy.a.05.p.2': 'Specifically, outsourcing may occur in connection with system maintenance and operation services and email delivery services.',

  // Article 6 content
  'privacy.a.06.p.0': 'The Association takes necessary and appropriate measures to prevent leakage, loss, or damage of personal information and to ensure the safe management of personal information.',
  'privacy.a.06.p.1': 'Specifically, the Association implements measures including access controls, anti-virus protection, information encryption, and staff education and supervision.',
  'privacy.a.06.p.2': 'However, given the nature of the internet, the Association cannot guarantee complete security. The Association strives to improve security within reasonable limits.',

  // Article 7 content
  'privacy.a.07.p.0': 'Where an individual requests disclosure, correction, addition, deletion, suspension of use, erasure, or cessation of provision to third parties (collectively, "Disclosure Requests") of personal data held by the Association, the Association will verify the identity of the requester and respond within a reasonable period in accordance with applicable law.',
  'privacy.a.07.p.1': 'Disclosure Requests should be submitted via the contact details provided below.',
  'privacy.a.07.p.2': 'Please note that a fee equivalent to actual costs may be charged in connection with disclosure requests.',

  // Article 8 content
  'privacy.a.08.p.0': 'This website may use cookies and access analytics tools such as Google Analytics to analyse website traffic and improve services.',
  'privacy.a.08.p.1': 'Cookies are small text files stored on the user\'s browser and are used to understand how the website is being used.',
  'privacy.a.08.p.2': 'Users may refuse or delete cookies through their browser settings. Please note that disabling cookies may affect the proper functioning of certain features of this website.',

  // Article 9 content
  'privacy.a.09.p.0': 'For enquiries regarding this Privacy Policy or the handling of personal information, please contact us as follows.',
  'privacy.a.09.p.1': 'The All Japan Butler Association – Personal Information Protection Officer',
  'privacy.a.09.p.2': 'Email: info@butler-academy.jp',
  'privacy.a.09.p.3': 'Telephone: 03-6824-4086 (Weekdays 10:00–17:00)',
  'privacy.a.09.p.4': 'Upon receipt, we will review your enquiry and respond through our relevant department.',

  // Article 10 content
  'privacy.a.10.p.0': 'The Association may revise this Privacy Policy without prior notice in connection with changes to laws or business activities.',
  'privacy.a.10.p.1': 'Significant changes will be announced on this website.',
  'privacy.a.10.p.2': 'Any revised Privacy Policy shall take effect upon publication on this website.',
  'privacy.a.10.p.3': 'Effective Date: To be announced',
};

export default privacy;
